document.addEventListener('click', (event) => {
  const btn = event.target.closest('.rcfr-chip');
  if (!btn) return;

  const root = btn.closest('.rcfr-root');
  if (!root) return;

  const key = btn.getAttribute('data-target');

  for (const chip of root.querySelectorAll('.rcfr-chip')) {
    chip.classList.toggle('is-active', chip === btn);
  }

  for (const panel of root.querySelectorAll('.rcfr-panel')) {
    panel.hidden = panel.getAttribute('data-panel') !== key;
  }
});
